module.exports = __webpack_public_path__ + "7038537bf0e07c9ac1e0e8c74372e251.svg";